// extracted by mini-css-extract-plugin
export default {"main":"style_main__EEp6w","home":"style_home__qYKMm","img6":"style_img6__-SWmw","img5":"style_img5__ow0W7"};